import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// Vue.directive('lazyload',{
//   inserted:(el)=>{
//     const observer = new IntersectionObserver((entries,observer)=>{
//       entries.forEach((entry) => {
//         if(entry.isIntersecting){
//           el.setAttribute('src',el.getAttribute('data-src'));
//           observer.unobserve(el);
//         }
//       });
//     })
//     observer.observe(el);
//   }
// })

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
